export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-trapezoid-reversed.81adf9cb.webp";